import React from "react";
import { NavLink } from "react-router-dom";
import "../../Styles/UserDashboard/Gestion.css";
import cheklist from "../assets/Images/icone/checklist.png";
import user from "../assets/Images/icone/user.png";
import comment from "../assets/Images/icone/comment.png";
import avi from "../assets/Images/icone/etoiles-de-notation.png";
import bon from "../assets/Images/icone/coupon.png";
import favorie from "../assets/Images/icone/favorie.png";
import vu from "../assets/Images/icone/eye.png";
import compte from "../assets/Images/icone/utilisateur.png";
import adresse from "../assets/Images/icone/location.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightFromBracket } from "@fortawesome/free-solid-svg-icons";

const menuItems = [
  { to: "/user", icon: user, label: "Mon profil", end: true },
  { to: "/user/Commandes", icon: cheklist, label: "Mes commandes" },
  { to: "/user/messages", icon: comment, label: "Boîte de réception" },
  { to: "/user/avis", icon: avi, label: "Mes avis" },
  { to: "/user/bons", icon: bon, label: "Bons d'achat" },
  { to: "/user/favoris", icon: favorie, label: "Favoris" },
  { to: "/user/products_vus", icon: vu, label: "Vus récemment" },
  { to: "/user/gestion", icon: compte, label: "Gestion du compte" },
  { to: "/user/adresses", icon: adresse, label: "Mon adresse" },
];

const Sidebar = ({ onNavigate }) => {
  const handleClick = () => onNavigate?.();

  return (
    <div className="sidebar-wrapper">
      <ul className="sidebar-list list-unstyled">
        {menuItems.map(({ to, icon, label, end }) => (
          <li key={to}>
            <NavLink
              to={to}
              end={end}
              onClick={handleClick}
              className={({ isActive }) =>
                "sidebar-item" + (isActive ? " active-link" : "")
              }
            >
              <img className="sidebar-icon" src={icon} alt="" />
              <span className="sidebar-label">{label}</span>
            </NavLink>
          </li>
        ))}

        {/* Déconnexion */}
        <li>
          <NavLink
            to="/user/logout"
            onClick={handleClick}
            className="sidebar-item sidebar-logout"
          >
            <FontAwesomeIcon
              icon={faRightFromBracket}
              className="sidebar-icon-fa"
            />
            <span className="sidebar-label">Déconnexion</span>
          </NavLink>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;